export default __webpack_public_path__ + "fonts/d8c37c96ec7fad30300628abe7adaa30.ttf";